import React from 'react';
import { ArrowRightIcon, BuildingIcon, ShoppingBagIcon, BotIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function HomePage() {
  return <div className="w-full" data-id="element-471">
      {/* Hero Section */}
      <section className="bg-black text-white relative" data-id="element-472">
        <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-473">
          <img src="https://images.unsplash.com/photo-1582719508461-905c673771fd?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80" alt="Modern Architecture" className="w-full h-full object-cover opacity-50" data-id="element-474" />
        </div>
        <div className="container mx-auto px-4 py-20 md:py-32 bg-pattern relative z-10" data-id="element-475">
          <div className="max-w-3xl" data-id="element-476">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-477">
              Transforming Industries Through Innovation
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8" data-id="element-478">
              Rawfounders is a global corporate umbrella brand with diverse
              ventures spanning hospitality, commerce, and AI technology.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-479">
              <Button href="/ventures" size="lg" data-id="element-480">
                Explore Our Services
              </Button>
              <Button href="/contact" variant="outline" size="lg" className="border-white text-white hover:bg-gray-900" data-id="element-481">
                Contact Us
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* About Section */}
      <section className="py-16 md:py-24 bg-white" data-id="element-482">
        <div className="container mx-auto px-4" data-id="element-483">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-484">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-485">
              About Rawfounders
            </h2>
            <p className="text-lg text-gray-600" data-id="element-486">
              Rawfounders is a forward-thinking corporate group that builds,
              acquires, and scales innovative businesses across multiple
              industries. We combine entrepreneurial vision with corporate
              expertise to create sustainable value and growth.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-487">
            <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-488">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-489">
                <span className="text-black text-2xl font-bold" data-id="element-490">01</span>
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-491">Vision</h3>
              <p className="text-gray-600" data-id="element-492">
                To be a global leader in building innovative businesses that
                transform industries and create lasting value.
              </p>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-493">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-494">
                <span className="text-black text-2xl font-bold" data-id="element-495">02</span>
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-496">Mission</h3>
              <p className="text-gray-600" data-id="element-497">
                To identify opportunities, build innovative solutions, and
                create sustainable businesses that deliver exceptional value.
              </p>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg text-center" data-id="element-498">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-499">
                <span className="text-black text-2xl font-bold" data-id="element-500">03</span>
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-501">Values</h3>
              <p className="text-gray-600" data-id="element-502">
                Innovation, integrity, excellence, and a relentless focus on
                delivering value to our customers and partners.
              </p>
            </div>
          </div>
          <div className="text-center mt-12" data-id="element-503">
            <Button href="/about" variant="outline" data-id="element-504">
              Learn More About Us
            </Button>
          </div>
        </div>
      </section>
      {/* Services Section */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-505">
        <div className="container mx-auto px-4" data-id="element-506">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-507">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-508">
              Our Services
            </h2>
            <p className="text-lg text-gray-600" data-id="element-509">
              Discover our portfolio of innovative businesses spanning multiple
              industries, each designed to lead and transform their respective
              markets.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-510">
            <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-511">
              <div className="mb-6" data-id="element-512">
                <BuildingIcon className="h-12 w-12 text-black" data-id="element-513" />
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-514">
                Rawfound Properties
              </h3>
              <p className="text-gray-600 mb-6 flex-grow" data-id="element-515">
                Specialized hospitality brokerage, consulting, and investor
                advisory services for the global hotel industry.
              </p>
              <a href="#" className="text-black font-medium inline-flex items-center" data-id="element-516">
                Learn More <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-517" />
              </a>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-518">
              <div className="mb-6" data-id="element-519">
                <ShoppingBagIcon className="h-12 w-12 text-black" data-id="element-520" />
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-521">
                Shoplinky
              </h3>
              <p className="text-gray-600 mb-6 flex-grow" data-id="element-522">
                AI-powered influencer commerce platform enabling creators to
                monetize their content and build sustainable businesses.
              </p>
              <a href="#" className="text-black font-medium inline-flex items-center" data-id="element-523">
                Learn More <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-524" />
              </a>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-525">
              <div className="mb-6" data-id="element-526">
                <BotIcon className="h-12 w-12 text-black" data-id="element-527" />
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-528">
                Agentter.ai
              </h3>
              <p className="text-gray-600 mb-6 flex-grow" data-id="element-529">
                Advanced AI-powered agents for commerce and operations,
                streamlining business processes and enhancing customer
                experiences.
              </p>
              <a href="#" className="text-black font-medium inline-flex items-center" data-id="element-530">
                Learn More <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-531" />
              </a>
            </div>
          </div>
          <div className="text-center mt-12" data-id="element-532">
            <Button href="/ventures" data-id="element-533">View All Services</Button>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-black text-white" data-id="element-534">
        <div className="container mx-auto px-4 bg-pattern" data-id="element-535">
          <div className="max-w-4xl mx-auto text-center" data-id="element-536">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-537">
              Ready to Collaborate?
            </h2>
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-538">
              Whether you're interested in our services, seeking partnership
              opportunities, or exploring investment possibilities, we'd love to
              hear from you.
            </p>
            <Button href="/contact" size="lg" data-id="element-539">
              Contact Our Team
            </Button>
          </div>
        </div>
      </section>
    </div>;
}